import React from 'react'
import {
    InputOTP as OTPInput,
    InputOTPGroup,
    InputOTPSlot,
} from "./primitive"


type Props = {
    value: string
    onChange: (value: string) => void
    maxLength: number
    testId?: string
    /** Lands on the underlying `<input>`, so a `<Label htmlFor>` can target it. */
    id?: string
    disabled?: boolean
    autoFocus?: boolean
    /** Marks every slot `aria-invalid` (red border). Implied by `errorMessage`. */
    hasError?: boolean
    errorMessage?: string
}

function InputOTP({ value, onChange, maxLength, testId, id, disabled, autoFocus, hasError, errorMessage }: Props) {
    const invalid = hasError || !!errorMessage

    return (
        <div className="space-y-2" data-testid={testId}>
            <OTPInput
                id={id}
                maxLength={maxLength}
                value={value}
                onChange={onChange}
                disabled={disabled}
                autoFocus={autoFocus}
            >
                <InputOTPGroup>
                    {/* AWOPS-3496 — the slot index IS the semantic position of the digit in the
                        code, so unlike a list-row index it is a stable identity, not a proxy. */}
                    {[0, 1, 2, 3, 4, 5].map((index) => (
                        <InputOTPSlot
                            key={index}
                            index={index}
                            aria-invalid={invalid || undefined}
                            data-testid={testId ? `${testId}-slot-${index}` : undefined}
                            className='size-16 !text-2xl font-bold bg-canvas'
                        />
                    ))}
                </InputOTPGroup>
            </OTPInput>
            {errorMessage && (
                <p className="text-red-base text-sm" role="alert">
                    {errorMessage}
                </p>
            )}
        </div>
    )
}


export default InputOTP
